import { useNavigate } from 'react-router-dom'
import { ChevronRight, Info } from 'lucide-react'
import { useI18n } from '../i18n/useI18n'

/**
 * #1898 企画の詳細への導線。**企画ごとの枠の中に置く。**
 *
 * 当初はイベントのカードの末尾に「イベントの詳細をみる」を 1 つだけ置いていたが、
 * 中身はもともと企画 1 つ分の詳細 (説明・景品・出店店舗・参加方法) で、
 * スタンプラリー / AR宝探し / ミニゲームのどれの詳細なのかが分からなかった。
 * イベント (親) のページへは、イベントのカードのいちばん下の「イベントの詳細をみる」から辿る
 * (企画詳細からは辿らない — 自分で選んだ企画のページに関係の薄いものを出さない)。
 */
export default function StampProgramInfoButton({ programId }: { programId: string }) {
  const navigate = useNavigate()
  const { t } = useI18n()
  return (
    <button
      onClick={() => navigate(`/stamp-rally/program/${encodeURIComponent(programId)}`)}
      className="flex items-center justify-between rounded-2xl bg-white px-4 py-4 shadow-card tap-card"
    >
      <span className="flex items-center gap-3 font-body text-text-primary">
        <Info size={20} className="text-navy" />
        {t('stampRally.programInfoCta')}
      </span>
      <ChevronRight size={18} className="text-text-tertiary" />
    </button>
  )
}
